﻿import { truckBodiesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("truck-body"),
  endpoint: "truck-bodies",
  operations: truckBodiesOps,
  roleView: [ROLE.TRUCK_VIEW, ROLE.TRUCK_ADMIN],
  roleAdmin: [ROLE.TRUCK_ADMIN],
  singularName: (t) => t("Truck body"),
  name: (t) => t("Truck Bodies"),
  syncCustomerFilter: true,
});

export default conf;
